<template>
  <div class="file-detail scroll">
    <div v-if="selectedItemsNumber == 0">
      <center>
        <h5 class="mt-4 text-danger">
          {{ $t("pages.documents.select.title") }}
        </h5>
      </center>
    </div>
    <div v-else>
      <div v-if="selectedItem.extension == 'form' || (selectedItem.type === 'file' && selectedItem.document_type !== 'Default (Par défaut)')">
        <div class="row" v-if="fetchingData">
          <b-skeleton animation="fade" class="mb-2" type="input" width="85%"></b-skeleton>
          <b-skeleton animation="fade" class="mb-2" type="input" width="90%"></b-skeleton>
          <b-skeleton animation="fade" class="mb-2" type="input" width="70%"></b-skeleton>
          <b-skeleton animation="fade" class="mb-2" type="input" width="85%"></b-skeleton>
          <b-skeleton animation="fade" class="mb-2" type="input" width="90%"></b-skeleton>
          <b-skeleton animation="fade" class="mb-2" type="input" width="70%"></b-skeleton>
        </div>
        <div class="row" v-if="documentMetadataValues.length === 0">
          <div class="col-12">
            <transition name="fade">
              <form @submit.prevent="onSubmit" ref="form">
                <div class="form-group" v-for="(documentMetadata, index) in documentMetadatas" :key="index">
                  <div v-if="documentMetadata.type == 'text'">
                    <label :for="documentMetadata.id" class="text-left">
                      {{ documentMetadata.label }}
                    </label>
                    <textarea rows="5" autocomplete="off" :name="documentMetadata.id"
                      v-model="documentMetadata.newValue" v-if="documentMetadata.required == 1"
                      :id="documentMetadata.id" class="form-control" :required="documentMetadata.required"></textarea>
                    <textarea rows="3" autocomplete="off" :name="documentMetadata.id"
                      v-model="documentMetadata.newValue" v-else :id="documentMetadata.id"
                      class="form-control"></textarea>
                  </div>
                  <div v-else-if="documentMetadata.type === 'boolean'">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" v-model="documentMetadata.newValue" class="custom-control-input"
                        :id="documentMetadata.id" :required="documentMetadata.required" />
                      <label class="custom-control-label" :for="documentMetadata.id">
                        <span class="badge badge-default">
                          {{ documentMetadata.label }}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="documentMetadata.type === 'list'">
                    <label class="text-left">
                      {{ documentMetadata.label }}
                    </label>
                    <select name="" id="" v-model="documentMetadata.newValue" class="form-control" :required="documentMetadata.required">
                      <option v-for="(option, index) in documentMetadata.options" :key="index">
                        {{option.option_label}}
                      </option>
                    </select>
                  </div>
                  <div v-else>
                    <label :for="documentMetadata.id" class="text-left">
                      {{ documentMetadata.label }}
                    </label>
                    <input autocomplete="off" :name="documentMetadata.id" v-model="documentMetadata.newValue"
                      v-if="documentMetadata.required == 1" v-on:change="onChangeFile($event, documentMetadata.label)"
                      :id="documentMetadata.id" :type="documentMetadata.type" class="form-control" :required="documentMetadata.required" />
                    <input autocomplete="off" :name="documentMetadata.id" v-model="documentMetadata.newValue" v-else
                      v-on:change="onChangeFile($event, documentMetadata.label)" :id="documentMetadata.id"
                      :type="documentMetadata.type" class="form-control" :required="documentMetadata.required" />
                  </div>
                </div>
                <div v-if="selectedItem.acl === 2">
                  <button type="submit" v-if="isLoading === false" class="btn col- btn-primary">
                    {{ $t("filemanager.btn.submit") }}
                  </button>
                </div>
              </form>
            </transition>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12">
            <transition name="fade">
              <form @submit.prevent="onUpdate" ref="form">
                <div class="form-group" v-for="(documentMetadata, index) in documentMetadataValues" :key="index">
                  <div v-if="documentMetadata.type === 'text'">
                    <label :for="documentMetadata.id">
                      {{ documentMetadata.label }}
                    </label>
                    <textarea rows="3" autocomplete="off" :name="documentMetadata.id" v-model="documentMetadata.value"
                      v-if="documentMetadata.required == 1" :id="documentMetadata.id" class="form-control"
                      :required="documentMetadata.required"></textarea>
                    <textarea rows="3" autocomplete="off" :name="documentMetadata.id" v-model="documentMetadata.value"
                      v-else :id="documentMetadata.id" class="form-control"></textarea>
                  </div>
                  <div v-else-if="documentMetadata.type === 'boolean'">
                    <div v-if="documentMetadata.value === '1'" class="custom-control custom-switch">
                      <input type="checkbox" v-model="documentMetadata.value" :value="true" class="custom-control-input"
                        :id="documentMetadata.id" />
                      <label class="custom-control-label" :for="documentMetadata.id">
                        <span class="badge badge-default">
                          {{ documentMetadata.label }}
                        </span>
                      </label>
                    </div>
                    <div v-else class="custom-control custom-switch">
                      <input type="checkbox" v-model="documentMetadata.value" :value="false"
                        class="custom-control-input" :id="documentMetadata.id" />
                      <label class="custom-control-label" :for="documentMetadata.id">
                        <span class="badge badge-default">
                          {{ documentMetadata.label }}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div v-else-if="documentMetadata.type === 'list'">
                    <label class="custom-control-label" :for="documentMetadata.id">
                      {{ documentMetadata.label }}
                    </label>
                    <select v-model="documentMetadata.value" :id="documentMetadata.id" class="form-control">
                      <option v-for="(option, index) in documentMetadata.options" :key="index">
                        {{option.option_label}}
                      </option>
                    </select>
                  </div>
                  <div v-else-if="documentMetadata.type === 'file'">
                    <label class="custom-control-label" :for="documentMetadata.id">
                      {{ documentMetadata.label }}
                    </label>
                    <br>
                    <h6 class="mt-2 attachment" @click="donwloadFile(documentMetadata.value)">
                      {{ documentMetadata.value}}
                    </h6>
                  </div>
                  <div v-else>
                    <label :for="documentMetadata.id">
                      {{ documentMetadata.label }}
                    </label>
                    <input autocomplete="off" :name="documentMetadata.metadata_id" v-model="documentMetadata.value"
                      v-if="documentMetadata.required == 1" :id="documentMetadata.metadata_id"
                      v-on:change="onChangeFile($event, documentMetadata.label)" :type="documentMetadata.type"
                      class="form-control" required />
                    <input :name="documentMetadata.metadata_id" v-model="documentMetadata.value" v-else
                      :id="documentMetadata.metadata_id" v-on:change="onChangeFile($event, documentMetadata.label)"
                      :type="documentMetadata.type" class="form-control" />
                  </div>
                </div>
                <div v-if="selectedItem.acl === 2">
                  <button type="submit" v-if="isLoading === false" class="btn col- btn-primary">
                    {{ $t("filemanager.btn.edit") }}
                  </button>
                  <button class="btn col-4 btn-primary" type="button" v-else disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                </div>
              </form>
            </transition>
          </div>
        </div>
      </div>
      <div v-else>
        <transition name="fade" appear>
          <div class="empty-state text-center">
            <i class="bx bxs-file mb-3"></i>
            <h5 class="mb-3">{{ $t('pages.metadata.inactiveMeta') }}</h5>
            <p>{{ $t('pages.metadata.noMeta') }}</p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import modal from "../modals/mixins/modal";
// import Loading from 'vue-loading-overlay';
import helper from "../../router/mixins/helper";
import EventBus from "../eventBus";
import axios, { getAuthHeaders, getFormDataHeaders } from "../../api/config";

export default {
  name: "FileDetail",
  mixins: [modal, helper],
  components: {
    // Loading,
  },
  data() {
    return {
      url: null,
      newFiles: [],
      documentMetadatas: [],
      documentType: {},
      docMetadata: {},
      documentMetadataValues: [],
      documentMetadata: {},
      metadata: [],
      isLoading: false,
      fetchingData: false,
      metadataOptions: [],
    };
  },
  computed: {
    /**
     * Selected disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters["selectedDisk"];
    },

    /**
     * Selected file
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters["selectedItems"][0];
    },

    /**
     * number of select items
     * @returns {Number}
     */
    selectedItemsNumber() {
      return this.$store.getters["selectedItems"].length;
    },

    /**updating **/
    imageExtensions() {
      return this.$store.state.settings.imageExtensions;
    },
  },
  methods: {
    onSubmit() {
      const metadatas = this.documentMetadatas.map((metadata) => {
        console.log("Type : ", typeof metadata.newValue);
        if (metadata.type === "boolean") {
          if (typeof metadata.newValue === "undefined") {
            return {
              id: metadata.id,
              label: metadata.label,
              type: metadata.type,
              newValue: false,
              pivot: metadata.pivot,
              required: metadata.required,
              created_at: metadata.created_at,
              updated_at: metadata.updated_at,
            };
          } else {
            return {
              id: metadata.id,
              label: metadata.label,
              type: metadata.type,
              newValue: Boolean(metadata.newValue),
              pivot: metadata.pivot,
              required: metadata.required,
              created_at: metadata.created_at,
              updated_at: metadata.updated_at,
            };
          }
        } else {
          if(metadata.type === 'file') {
            // upload files
            for(let i = 0; i < this.newFiles.length; i++) {
              if(this.newFiles[i].label.trim() == metadata.label) {
                let file = this.newFiles[i].file;
                return {
                  id: metadata.id,
                  label: metadata.label,
                  type: metadata.type,
                  newValue: file,
                  pivot: metadata.pivot,
                  created_at: metadata.created_at,
                  updated_at: metadata.updated_at,
                };
              }
            }

          } else {
            if (typeof metadata.newValue === 'undefined') {
              return {
                id: metadata.id,
                label: metadata.label,
                type: metadata.type,
                newValue: "-",
                pivot: metadata.pivot,
                created_at: metadata.created_at,
                updated_at: metadata.updated_at,
              };
            }
            return {
              id: metadata.id,
              label: metadata.label,
              type: metadata.type,
              newValue: metadata.newValue,
              pivot: metadata.pivot,
              created_at: metadata.created_at,
              updated_at: metadata.updated_at,
            };
          }
        }
      });

      const filesMetadata = metadatas.filter((e) => e.type === "file");
      const othersMetadata = metadatas.filter((e) => e.type !== "file");
      console.log("Other metadata : ", othersMetadata);
      const othersMetadataJson = JSON.stringify(othersMetadata);

      const formData = new FormData();
      formData.append('documentId', JSON.stringify(this.selectedItem.doc_id));
      formData.append('jsonData', othersMetadataJson);

      filesMetadata.forEach(fileMetadata => {
        formData.append("files[]", fileMetadata.newValue, fileMetadata.id)
      });

      this.isLoading = true;
      axios
        .post(`/document-metadata`, formData, { headers: getFormDataHeaders() })
        .then(() => {
          this.getDocumentMetadataValue(
            this.$store.getters["selectedItems"][0].doc_id,
            'submitting'
          );
          this.isLoading = false;
          this.$toasted.success("Document indexé avec succès");
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.isLoading = false;
            this.$toasted.error(this.$t("pages.metadata.indexed"));
          } else {
            this.isLoading = false;
            this.$toasted.error(this.$t("pages.unauthorized.error_0"));
          }
        });
    },
    onChangeFile(event, label) {
      const file = Array.from(event.target.files)[0];
      this.newFiles.unshift({
        file,
        label,
        type: null
      });
      console.log("EVENT : ", file);
    },
    donwloadFile(file) {
      this.$swal({
          text: this.$t("filemanager.file-details.download"),
          showCancelButton: true,
          confirmButtonColor: "#063970",
          cancelButtonText: this.$t("filemanager.file-details.cancelBtn"),
          confirmButtonText: this.$t("filemanager.file-details.confirmBtn"),
        }).then((result) => {
          if (result.value) {
            const disk = "public";
            const path = "metadata_files/"+file;

            this.$store
              .dispatch("getAttachment", { disk, path })
              .then((response) => {
                if (response.status === 200) {
                  var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                  var fileLink = document.createElement("a");

                  fileLink.href = fileURL;
                  fileLink.setAttribute("download", file);
                  document.body.appendChild(fileLink);

                  fileLink.click();
                }
              })
              .catch(() => {});
          }
        })
    },
    onUpdate() {
      this.isLoading = true;
      axios
        .put(`/document-metadata`, this.documentMetadataValues, {
          headers: getAuthHeaders(),
        })
        .then(() => {
          console.log("Est-ce là : ", this.documentMetadataValues);
          this.isLoading = false;
          this.$toasted.success("Informations Modifiées avec succès");
        })
        .catch(() => {
          this.isLoading = false;
          this.$toasted.error(this.$t("pages.unauthorized.error_0"));
        });
    },
    /**
     * Get URL
     */
    getUrl() {
      this.$store
        .dispatch("url", {
          disk: this.selectedDisk,
          path: this.selectedItem.path,
        })
        .then((response) => {
          if (response.data.result.status === "success") {
            this.url = response.data.url;
          }
        });
    },

    getDocumentTypeMetadas(id) {
      axios
        .get(`/document-types/${id}`, { headers: getAuthHeaders() })
        .then((response) => {
          if (response.status == 200) {
            this.documentMetadatas = response.data.Metadata;
            this.fetchingData = false;
          }
        })
        .catch(() => {
          this.fetchingData = false;
        });
    },

    getDocumentMetadataValue(docId, context) {
      this.fetchingData = context === 'fetching' ? true : false;
      axios
        .get(`/document-metadata/${docId}`, { headers: getAuthHeaders() })
        .then((response) => {
          console.log("Document metadata value : ", response);
          if (response.status == 200) {
            this.metadataOptions = response.data.MetadataOptions;
            if (response.data.MetadataValues.length === 0) {
              this.getDocumentTypeMetadas(
                this.$store.getters["selectedItems"][0].type_id
              );
            } else {
              this.fetchingData = false;
              this.documentMetadataValues = response.data.MetadataValues.map(
                (metadata) => {
                  if (metadata.type === "boolean") {
                    if (metadata.value === "0") {
                      return {
                        id: metadata.id,
                        label: metadata.label,
                        type: metadata.type,
                        value: false,
                        metadata_id: metadata.metadata_id,
                        created_at: metadata.created_at,
                      };
                    } else {
                      return {
                        id: metadata.id,
                        label: metadata.label,
                        type: metadata.type,
                        value: true,
                        metadata_id: metadata.metadata_id,
                        created_at: metadata.created_at,  
                      };
                    }
                  } 
                  else if(metadata.type === "list") {
                    return {
                      id: metadata.id,
                      label: metadata.label,
                      type: metadata.type,
                      value: metadata.value,
                      options: metadata.options,
                      metadata_id: metadata.metadata_id,
                      created_at: metadata.created_at,
                    };
                  } 
                  else {
                    return {
                      id: metadata.id,
                      label: metadata.label,
                      type: metadata.type,
                      value: metadata.value,
                      metadata_id: metadata.metadata_id,
                      created_at: metadata.created_at,
                    };
                  }
                }
              );
            }
          }
        });
    },

    /**
     * Copy text to clipboard
     * @param text
     */
    copyToClipboard(text) {
      // create input
      const copyInputHelper = document.createElement("input");
      copyInputHelper.className = "copyInputHelper";
      document.body.appendChild(copyInputHelper);
      // add text
      copyInputHelper.value = text;
      copyInputHelper.select();
      // copy text to clipboard
      document.execCommand("copy");
      // clear
      document.body.removeChild(copyInputHelper);

      // Notification
      EventBus.$emit("addNotification", {
        status: "success",
        message: this.lang.notifications.copyToClipboard,
      });
    },

    /**
     * Check file extension (image or no)
     * @param extension
     * @returns {boolean}
     */
    thisImage(extension) {
      // extension not found
      if (!extension) return false;

      return this.imageExtensions.includes(extension.toLowerCase());
    },
  },
  created() {
    this.isMounting = true;
    this.getDocumentMetadataValue(
      this.$store.getters["selectedItems"][0].doc_id,
      'fetching'
    );
  },
};
</script>

<style lang="scss">
.file-detail {
  margin-top: 20px;
  text-align: left;
  word-wrap: break-word;
  overflow-y: scroll;
  height: 100%;
  .row {
    margin-bottom: 0.3rem;
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;

    .fa-copy {
      padding-top: 0.2rem;
      display: none;
      cursor: pointer;
    }

    &:hover {
      & .fa-copy {
        display: block;
      }
    }
  }

  .attachment {
    background-color: #7EAFD7;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    padding: 15px;
  }

  .attachment:hover {
    background-color: #06497e;
    color: white;
  }

  .col-2 {
    font-weight: bold;
  }

  .col-9 {
    word-wrap: break-word;
  }
}
</style>
